import { useCompareData } from 'global/cnr/contexts/useHelpers/useCompareData'
import { useRecreateData } from 'global/cnr/contexts/useHelpers/useRecreateData'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Dropdown, Icon, Label } from 'semantic-ui-react'
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent'
import { GoogleSheetsContext } from '../../cnr/contexts/GoogleSheetsContext'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { viewDataModes } from '../../cnr/reducers/DataManagmentReducer'
import { googleSheetsTypes, googleViewTypes } from '../../cnr/reducers/GoogleSheetsReducer'
import { getUniquePropKeys } from '../../common/filtering'
import { appIconTypes } from '../../enums/appIconTypes'
import { iconColorTypes } from '../../enums/settingsIconTypes'
import { listHelpers } from '../../lists/lists'
import { createGoogleSheetKeys, validateCollectionArrays } from '../../validation/validation'
import { openExternal } from '../../viewSettings/helpers/settingsLinks'
import TransitionWrapper, { transitionWrapperTypes } from '../../wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import WrapperVertCols from '../../wrappers/WrapperVertCols'
import UiSaveButtons from '../buttons/UiSaveButtons'
import DropdownOptionsMenu from '../forms/elements/DropdownOptionsMenu'
import TreeViewer from './TreeViewer'
import { deleteField } from 'firebase/firestore'
import { useGoogleSheets } from 'global/cnr/contexts/useHelpers/useGoogleSheets'

const ddIcons = {
  action: 'content',
  dataOptions: 'unordered list',
  updateOptions: 'unordered list',
}

const _viewTypes = {
  gs_app: 'gs_app',
  app_gs: 'app_gs',
  gs: 'gs',
}

const _menuSize = 'small'

const GoogleSheetsTabs = (props) => {

  const { handleCreate, fromCreate, setViewDataMode, googleSheetType } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fn_cls } = parentContext ?? {}
  const { currentSettings_state, paps_state, eventInfo_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { googleSheetsId: gsid } = _.get(currentSettings_state, 'gvviSettings.aps_global.googleSheets', {});
  const { appDataDocuments: appDataDocuments_event, appDataLinks: _appDataLinks } = eventInfo_state ?? {}

  // googleSheetsContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state } = frameworkContext ?? {}
  const { frInfo, frameworkRightType } = framework_state ?? {}
  const { uivi } = frInfo ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_state, googleSheets_handlers } = googleSheetsContext ?? {}
  const {
    _newCounts,
    activeMenuItem,
    changedItems,
    currentCount,
    dashboardInfo_merged,
    dashboardInfo_preview_alt,
    dataCollection,
    dataCounts,
    googleActiveDataItems, // google data
    googleFilteredDataItems,
    googleSheetItems,
    googleSheetsData,
    googleSheetsId,
    googleSheetsPreview,
    googleViewType,
    itemChanges,
    missingItems,
    newItems,
    result_fromGoogle,
    selectedProp,
    updating: updating_gs,
  } = googleSheets_state ?? {}

  console.log('currentSettings_state', currentSettings_state)

  const props_di = googleActiveDataItems && getUniquePropKeys(googleActiveDataItems)

  const appDataLinks = googleSheetsPreview?.appDataLinks
  const appDataDocuments = googleSheetsPreview?.appDataDocuments
  const dataCollections = googleSheetsPreview?.projectData?.dataCollections
  const settings_google = googleSheetsPreview?.projectSettings
  const settings_google_app_gs = dashboardInfo_preview_alt?.previewSettings_app_gs
  const settings_google_gs_app = dashboardInfo_preview_alt?.previewSettings_gs_app
  const viewItems_gs = googleSheetsPreview?.projectSettings?.viewItems
  const gsTitle = googleSheetsPreview?.projectData?.eventData?.['1']?.name
  const props_gs = _.keys(viewItems_gs?.[uivi]?.props)

  const prpps_merged = _.union(props_di, props_gs);
  const opts = listHelpers.listList(prpps_merged)

  const _useSingleItem = frameworkRightType === 'google' ? true : false
  const viewItem = aps_viewItems[activeMenuItem]
  const _appDataDocument = appDataDocuments_event?.[activeMenuItem]

  const { getAppDataDiffs } = useCompareData()
  const { updateCollectionsData, updateSettingsData, filterData, updating: _updating } = useRecreateData()
  const { getDataFromGoogleSheets, fetching } = useGoogleSheets()

  // data diffs between 
  const { appDataDiffs } = useMemo(() => {
    return getAppDataDiffs({ appData: appDataDocuments_event, sheetsData: googleSheetsData })
  }, [googleSheetsData, appDataDocuments_event])

  const { appDataDiff, appDataDiffCounts } = useMemo(() => {
    if (_.isEmpty(appDataDiffs) || !activeMenuItem) return { appDiff: null };
    const _appDataDiff = appDataDiffs?.[activeMenuItem]
    const { compares } = _appDataDiff ?? {}
    const { counts } = compares ?? {}
    return { appDataDiff: _appDataDiff, appDataDiffCounts: counts }
  }, [appDataDiffs, activeMenuItem])

  const { appItemUpdateData, appItemUpdateData_filtered } = useMemo(() => {

    if (_.isEmpty(appDataDiff) || !activeMenuItem) return { appItemUpdateData: {} };

    let _appItemUpdateData_filtered = null;

    if (selectedProp) {
      _appItemUpdateData_filtered = filterData({ data: googleActiveDataItems, selectedProp, allowNames: true })
    }

    const { props } = viewItem ?? {}
    const { props: props_gs } = settings_google?.viewItems?.[activeMenuItem] ?? {}
    const keys_props = _.keys(props)
    const keys_props_gs = _.keys(props_gs)

    const _diffs = _.difference(
      _.difference(keys_props, keys_props_gs),
      _.keys(aps_viewItems)
    );

    const { compares } = appDataDiff ?? {}
    let aiud = null;
    switch (googleViewType) {
      case googleViewTypes.new:
        aiud = compares?.sheetsOnly
        break;
      case googleViewTypes.all:
        aiud = googleActiveDataItems
        break;
      case googleViewTypes.changed:
        aiud = compares?.differents
        break;
      case googleViewTypes.filtered:
      // nothing
    }
    return {
      appItemUpdateData: aiud,
      appItemUpdateData_filtered: _appItemUpdateData_filtered
    }
  }, [appDataDiff, activeMenuItem, googleViewType, googleActiveDataItems, selectedProp])

  // local state    
  const [updating, setUpdating] = useState()
  const [useItemKey, setUseItemKey] = useState()
  const [selectedKeys, setSelectedKeys] = useState()
  const [showConfirmation, setShowConfirmation] = useState()
  const [viewType, setViewType] = useState(_viewTypes.gs)

  const [showConfirm_delete, setShowConfirm_delete] = useState()
  const [showConfirm_update, setShowConfirm_update] = useState()
  const [showConfirm_settings, setShowConfirm_settings] = useState()

  const [selectedAppItem, setSelectedAppItem] = useState()
  const [selectedGsItem, setSelectedGsItem] = useState()

  const [selectType, setSelectType] = useState()

  const [_settings_google, set_settings_google] = useState(settings_google)
  const [_settings_google_gs_app, set_settings_google_gs_app] = useState(settings_google_gs_app)

  const _isUpdating = updating || updating_gs || _updating

  const handleViewType = (vt) => setViewType(vt)

  const handlePropChange = (e, data) => {
    const { value } = data
    googleSheets_handlers.handleAmmend_selectedProp(value)
  }

  const markChangedItems = (dc, add) => {
    _.forEach(dc, (dataItem, key) => {
      const correspondingItem = add[key];
      if (correspondingItem && !_.isEqual(dataItem, correspondingItem)) {
        dataItem._changed = true;
      }
    });
  };

  const getBadPathsWithReasons = (obj, path = '') => {
    let issues = [];

    const currentPath = path || 'root';

    if (_.isNil(obj)) {
      issues.push({ path: currentPath, reason: obj === null ? 'Null value' : 'Undefined value' });
    } else if (_.isArray(obj)) {
      if (_.isEmpty(obj)) {
        issues.push({ path: currentPath, reason: 'Empty array' });
      } else {
        obj.forEach((item, index) => {
          issues = issues.concat(getBadPathsWithReasons(item, `${currentPath}[${index}]`));
        });
      }
    } else if (_.isPlainObject(obj)) {
      if (_.isEmpty(obj)) {
        issues.push({ path: currentPath, reason: 'Empty object' });
      } else {
        _.forEach(obj, (val, key) => {
          issues = issues.concat(getBadPathsWithReasons(val, `${currentPath}.${key}`));
        });
      }
    }

    return issues;
  };


  const openJsonInNewTab = () => {
    try {

      const bpwr = getBadPathsWithReasons(dataCollections)
      // const parsed = JSON.parse(googleSheetsPreview); // Ensure it's valid JSON
      const formatted = JSON.stringify(dataCollections, null, 2); // Pretty-print with 2-space indent

      const blob = new Blob([formatted], { type: "application/json" });
      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');
    } catch (e) {
      console.error("Invalid JSON string", e);
    }
  };

  useEffect(() => {
    if (dataCollections) {
      // setUpdating(true)
      googleSheets_handlers.handleInit_googleSheetTabs()
      setUpdating(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuItem, dataCollections, _newCounts]);

  useEffect(() => {
    if (activeMenuItem) {
      googleSheets_handlers.handleInit_googleSheetActive(appDataDocuments_event)
      setUpdating(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuItem]);

  useEffect(() => {
    if (uivi && dataCollections) {
      googleSheets_handlers.handleSet_activeMenuItem(uivi)
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCollections, uivi]);

  const handleDataCollectionChange = (dmi) => {
    googleSheets_handlers.handleSet_activeMenuItem(dmi)
    activeMenuItem
    setShowConfirm_delete()
    setShowConfirm_update()
    googleSheets_handlers.handleAmmend_selectedProp()
  }

  const handle_showConfirmation = (opts) => {
    const { optionType } = opts
    setShowConfirmation(showConfirmation === optionType ? null : optionType)
  }

  const handleShow_confirm_remove = () => setShowConfirm_delete(!showConfirm_delete)
  const handleShow_confirm_update = () => setShowConfirm_update(!showConfirm_update)
  const handleShow_confirm_settings = () => setShowConfirm_settings(!showConfirm_settings)

  const handleConfirm_update = () => {
    const cb = () => setShowConfirm_update(false)

    let dataToUpdate = {
      [activeMenuItem]: { ...appItemUpdateData }
    }

    switch (googleViewType) {
      case googleViewTypes.filtered:
        dataToUpdate = {
          [activeMenuItem]: { ...appItemUpdateData_filtered }
        }
    }

    const opts = { allowUpdates: true, collectionKey: activeMenuItem, deletePrior: false, merge: false, selectedProp }
    switch (googleViewType) {
      case googleViewTypes.all:
        opts.deletePrior = selectedProp ? false : true
        opts.merge = false
        break;
    }
    updateCollectionsData({ dataToUpdate, opts, callback: cb })
  }

  const handleConfirm_settings = () => {
    const cb = () => setShowConfirm_settings(false)
    updateSettingsData({ viewItems: settings_google_app_gs?.viewItems_alt, views: settings_google_app_gs?.views_alt, callback: cb })
    const dataToUpdate = {
      [activeMenuItem]: { ...appItemUpdateData }
    }
    const opts = { allowUpdates: true, collectionKey: activeMenuItem, deletePrior: false, merge: false, selectedProp }
    // switch (googleViewType) {
    //   case googleViewTypes.all:
    //     opts.deletePrior = selectedProp ? false : true
    //     opts.merge = false
    //     break;
    // }
    // updateCollectionsData({ dataToUpdate, opts, callback: cb })
  }

  const handleCommit_remove = () => {
    const cb = () => setShowConfirm_delete(false)
    const { appOnly } = _.get(appDataDiff, 'compares', {});
    const dataToUpdate = {
      [activeMenuItem]: { ...appOnly }
    }
    const opts = { allowUpdates: true, collectionKey: activeMenuItem, deletePrior: false, merge: false, forRemove: true, selectedProp }
    updateCollectionsData({ dataToUpdate, opts, callback: cb })
  }

  const handleDatabaseOpen = () => openExternal.db(pathViews, null, [activeMenuItem])

  const handleGetGoogleSheet = () => {
    getDataFromGoogleSheets({
      gsid: googleSheetsId,
      useItemKey,
      callback: googleSheets_handlers.handleResponse_googleSheet
    })
  }

  const handleGoogleViewType = (googleViewType) => googleSheets_handlers.handleAmmend_ammendGoogleViewType(googleViewType)
  const handleOpenGoogleSheets = () => openExternal.googleSheets(googleSheetsId)

  const handleUpdateCollectionData = () => {
    googleSheets_handlers.handleStartUpdate()
    googleSheets_handlers.handleUpdate_dataCollectionsOneByOne(activeMenuItem)
  }

  const handleRecreateCollectionData = () => {
    googleSheets_handlers.handleStartUpdate()
    // collectionName, updateTheSettings, updateStaticViews, updateOnly, allowMerge, newOnly
    googleSheets_handlers.handleRecreate_dataCollectionsOneByOne(activeMenuItem, false, false, false, false)
    googleSheets_handlers.handleUpdate_dataCollectionsOneByOne(activeMenuItem)
  }

  const handleUpdateGoogleSheets = () => createGoogleSheetKeys(fn_cls, googleSheetsData, dataCollections)
  const handleValidateDataCollections = () => validateCollectionArrays(dataCollections)
  const handleViewDataMode = (opts) => setViewDataMode(opts ? opts.viewDataMode : null)

  const handlePrivate = (a, b) => {
    const _sg = { ..._settings_google_gs_app }
    const _b = b.split('.')
    if (_b.length === 4) {
      const _setting = _b[0];
      const _collection = _b[1];
      const _item = _b[2];
      const _prop = _b[3];
      if (_setting === 'viewItems' && _item === 'props') {
        if (_sg?.viewItems?.[_collection]?.props[_prop]) {
          const item = _sg.viewItems[_collection].props[_prop]
          item._isPrivate = !item._isPrivate
        }
      }
    }
    set_settings_google_gs_app(_sg)
  }

  const ims_appData = (data, hasSelectedProp) => {

    const hc = (item) => {
      setSelectedAppItem(item._itemKey === selectedAppItem?._itemKey ? null : item)
    }

    const fnAlt_data = (item) => {
      const compares = appDataDiffs?.[activeMenuItem]?.compares
      const { differents } = compares
      const diffs = differents?.[item?._itemKey]
      const lbls = []
      if (_appDataLinks?.[activeMenuItem]?.[item?._itemKey]) {
        lbls.push(<Icon name='linkify' color='grey' title={'Has Data Links'} />)
      }
      if (appDataDiffCounts?.appOnlyCount) {
        lbls.push(<Icon name='check circle outline' color='purple' title={'App Only'} />)
      }
      if (!_.isEmpty(diffs)) {
        lbls.push(<Label size='mini' circular color='red'>{_.size(diffs)}</Label>)
      }
      return <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>{lbls}</div>
    }

    const fnSub_data = (item) => {

      const { startDate, startTime } = item ?? {}

      if (item._itemKey === selectedAppItem?._itemKey) {

        const diffs = appDataDiffs?.[activeMenuItem]?.compares?.differents?.[item?._itemKey]

        if (_.isEmpty(diffs)) return;

        const fnAlt_item = (itemm) => {
          const { app, gs } = itemm ?? {}
          return <div style={{ display: 'flex', columnGap: '.25em' }}>
            <Label size='mini' color='black'>{app || '-'}</Label>
            <Label size='mini' color='blue'>{gs || '-'}</Label>
          </div>
        }

        return <div className='sqr-box-sub il'>
          <ItemMenuSquares
            menuItems={diffs}
            imsType={_imsTypes.inline}
            fn_altContent={fnAlt_item}
            noItemIcon={true}
          />
        </div>
      }

      if (startDate) {
        return <div className='sqr-box-sub il'>
          {`${startDate}: ${startTime}`}
        </div>
      }
    }

    return <ItemMenuSquares
      menuItems={data}
      activeItem={selectedAppItem?._itemKey}
      onClick={hc}
      imsType={_imsTypes.inline}
      fn_altContent={fnAlt_data}
      fn_subContentt={fnSub_data}
      noItemIcon={true}
    />
  }

  const ims_gsData = (data, isUpdateIms) => {

    const hc = (item) => setSelectedGsItem(item._itemKey === selectedGsItem?._itemKey ? null : item)

    const fnSub_update = (item) => {
      if (_.isEmpty(selectedProp) || googleViewType !== googleViewTypes.filtered) return;
      if (!_.isArray(selectedProp)) {
        return <div className='sqr-box-sub' style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
          <Label size='mini' color='black'>{item?.[selectedProp]}</Label>
        </div>
      } else {
        const divs = _.map(selectedProp, sp => (
          item?.[sp] && <Label size='mini' color='black'>{`${_.startCase(sp)}: ${item?.[sp]}`}</Label>
        ))
        return <div className='sqr-box-sub' style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
          {divs}
        </div>
      }
    }

    const fnAlt = (item) => {
      const compares = appDataDiffs?.[activeMenuItem]?.compares
      const { differents, sheetsOnly } = compares
      const diffs = differents?.[item?._itemKey]
      const gsOnly = sheetsOnly?.[item?._itemKey]
      const lbls = []
      if (!_.isEmpty(gsOnly)) {
        lbls.push(<Icon name='check circle outline' title={'GS Only'} color='purple' />)
      }
      if (!_.isEmpty(diffs)) {
        lbls.push(<Label size='mini' circular color='red'>{_.size(diffs)}</Label>)
      }
      return <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>{lbls}</div>
    }

    const fnSub = (item) => {

      const { startDate, startTime } = item ?? {}

      if (item._itemKey === selectedGsItem?._itemKey) {
        const diffs = appDataDiffs?.[activeMenuItem]?.compares?.differents?.[item?._itemKey]

        if (_.isEmpty(diffs)) return;

        const fnAlt_item = (itemm) => {
          const { app, gs } = itemm ?? {}
          return <div style={{ display: 'flex', columnGap: '.25em' }}>
            <Label size='mini' color='black'>{app || '-'}</Label>
            <Label size='mini' color='blue'>{gs || '-'}</Label>
          </div>
        }

        return <div className='sqr-box-sub'>
          <ItemMenuSquares
            menuItems={diffs}
            imsType={_imsTypes.inline}
            fn_altContent={fnAlt_item}
            noItemIcon={true}
          />
        </div>
      }

      if (startDate) {
        return <div className='sqr-box-sub il'>
          {`${startDate}: ${startTime}`}
        </div>
      }

    }
    return <ItemMenuSquares
      menuItems={data}
      activeItem={selectedGsItem?._itemKey}
      onClick={hc}
      imsType={_imsTypes.inline}
      fn_altContent={!isUpdateIms && fnAlt}
      fn_subContentt={isUpdateIms ? fnSub_update : fnSub}
      noItemIcon={true}
    />
  }

  const ddom_left = () => {
    const btns_dd = [{ caption: 'Open Database', oc: handleDatabaseOpen, icon: 'database', color: iconColorTypes.external }]
    btns_dd.push({ caption: 'Open Google Sheets', oc: handleOpenGoogleSheets, icon: appIconTypes.externalAlternate, color: iconColorTypes.external, disabled: !googleSheetsId })
    btns_dd.push({ caption: 'Refresh Google Sheets', oc: handleGetGoogleSheet, icon: appIconTypes.refresh, color: iconColorTypes.normal, disabled: !googleSheetsId })

    switch (googleSheetType) {
      case googleSheetsTypes.normal:
        btns_dd.push({ caption: 'Validate Google Sheets', oc: handleValidateDataCollections, icon: appIconTypes.refresh, color: iconColorTypes.normal, disabled: !googleSheetsId })
        btns_dd.push({ caption: 'Update Google Sheets Keys', oc: handleUpdateGoogleSheets, icon: appIconTypes.refresh, color: iconColorTypes.normal, disabled: !googleSheetsId })
        break;
      default:
      // nothing
    }
    return btns_dd.length > 0 && <DropdownOptionsMenu menuButtons={btns_dd} caption={'Actions'} icon={ddIcons.action} color={'blue'} float={'left'} />
  }

  const buttons_solo_confirmation = () => {
    const caption_update = !_.isEmpty(selectedProp) ? 'Update All (' + _.startCase(selectedProp) + ') From GS' : 'Update All!'
    const caption_recreate = !_.isEmpty(selectedProp) ? 'Recreate All (' + _.startCase(selectedProp) + ') From GS' : 'Recreate All'
    const btns_dd = []
    btns_dd.push({ caption: caption_recreate, oc: handleRecreateCollectionData, icon: appIconTypes.save, color: iconColorTypes.save, disabled: !googleSheetsId })
    btns_dd.push({ caption: caption_update, oc: handleUpdateCollectionData, icon: appIconTypes.save, color: iconColorTypes.save, disabled: !googleSheetsId })
    btns_dd.push({ caption: 'Cancel', oc: handle_showConfirmation, icon: appIconTypes.delete, color: iconColorTypes.remove, disabled: !googleSheetsId, fl: true })
    return <UiSaveButtons others={btns_dd} />
  }

  const buttons_top_full = () => {
    const _d = !googleSheetsPreview
    const _dm = !dashboardInfo_merged
    const _oc = handleViewDataMode
    const _icon = appIconTypes.arrowRight
    const btns = [
      { disabled: _dm, caption: _.startCase(viewDataModes.mergeDataCollections), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.mergeDataCollections, commitType: viewDataModes.mergeDataCollections } },
      { disabled: _d, caption: _.startCase(viewDataModes.mergeSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.mergeSettings } },
      { disabled: _d, caption: _.startCase(viewDataModes.mergeDataAndSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.mergeDataAndSettings } },

      { disabled: _d, caption: _.startCase(viewDataModes.recreateDataCollections), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateDataCollections, commitType: viewDataModes.recreateDataCollections } },
      { disabled: _d, caption: _.startCase(viewDataModes.recreateSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateSettings } },
      { disabled: _d, caption: _.startCase(viewDataModes.recreateDataAndSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateDataAndSettings } },
      // { disabled: _d, caption: _.startCase(viewDataModes.recreateDataDocuments), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateDataDocuments, commitType: viewDataModes.recreateDataDocuments } },
      { disabled: _d, caption: _.startCase(viewDataModes.recreateGlobalSettings), oc: _oc, icon: _icon, opts: { viewDataMode: viewDataModes.recreateGlobalSettings } },
    ]

    return <DropdownOptionsMenu menuButtons={btns} caption={'Data and Settings Options'} color={'blue'} icon={ddIcons.dataOptions} direction={'left'} />

  }

  // const buttons_footer_single = () => {
  //   const _oc = handleViewDataMode
  //   const _icon = appIconTypes.arrowRight
  //   const btns = []
  //   btns.push({ caption: _.startCase(viewDataModes.addNewDataCollection), oc: _oc, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.addNewDataCollection, commitType: viewDataModes.addNewDataCollection } })
  //   btns.push({ caption: _.startCase(viewDataModes.recreateDataCollection), oc: _oc, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.recreateDataCollection, commitType: viewDataModes.recreateDataCollection } })
  //   btns.push({ caption: _.startCase(viewDataModes.mergeDataCollection), oc: _oc, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.mergeDataCollection, commitType: viewDataModes.mergeDataCollection } })
  //   return <DropdownOptionsMenu menuButtons={btns} caption={'Data Options (' + _activeMenuItem + ')'} color={'blue'} icon={ddIcons.dataOptions} direction={'left'} />
  // }

  const buttons_footer_create = () => {
    const _oc = handleViewDataMode
    const _icon = appIconTypes.arrowRight
    const btns = []
    btns.push({ caption: _.startCase(viewDataModes.createEvent), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.createEvent } })
    btns.push({ caption: _.startCase(viewDataModes.createEvent_limited), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.createEvent_limited } })
    btns.push({ caption: _.startCase(viewDataModes.createGsEvent), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.createGsEvent } })
    btns.push({ caption: _.startCase(viewDataModes.recreateEvent), oc: handleCreate, icon: _icon, disabled: !activeMenuItem, opts: { viewDataMode: viewDataModes.recreateEvent } })
    btns.push({ caption: _.startCase('viewJson'), oc: openJsonInNewTab, icon: 'eye' })
    return <DropdownOptionsMenu menuButtons={btns} caption={'Create Options'} color={'blue'} icon={ddIcons.dataOptions} direction={'left'} />
  }

  const footer_main = () => <div>
    {ddom_left()}
    {/* {buttons_footer_single()} */}
  </div>

  const footer_create = () => <div>
    {buttons_footer_create()}
  </div>

  const wrapper_ims = (h, c, f) => <Wrapper
    header={h}
    content={c}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  // APP
  const footer_dataApp = () => {
    const btns = []
    btns.push({ caption: `Remove App Items Only (${appDataDiffCounts?.appOnlyCount})`, icon: 'arrow right', color: 'blue', oc: handleShow_confirm_remove, disabled: appDataDiffCounts?.appOnlyCount === 0 })
    return <UiSaveButtons others={btns} />
  }

  const footer_dataUpdate = (data) => {
    const btns = []
    btns.push({
      caption: `Update (${_.startCase(googleViewType)})`,
      icon: 'arrow right',
      color: 'blue',
      oc: handleShow_confirm_update,
      disabled: _.isEmpty(data)
    })
    return <UiSaveButtons others={btns} />
  }

  // commit
  const footer_dataApp_confirm = () => {
    const btns = []
    btns.push({ caption: `Confirm`, icon: 'check', color: 'red', oc: handleCommit_remove })
    btns.push({ caption: `Cancel`, icon: 'delete', fl: true, color: 'black', oc: handleShow_confirm_remove })
    return <UiSaveButtons others={btns} />
  }

  const footer_dataUpdate_confirm = () => {
    const btns = []
    btns.push({ caption: `Confirm`, icon: 'check', color: 'green', oc: handleConfirm_update })
    btns.push({ caption: `Cancel`, icon: 'delete', fl: true, color: 'black', oc: handleShow_confirm_update })
    return <UiSaveButtons others={btns} />
  }

  const footer_settings_confirm = () => {
    const btns = []
    btns.push({ caption: `Confirm`, icon: 'check', color: 'green', oc: handleConfirm_settings })
    btns.push({ caption: `Cancel`, icon: 'delete', fl: true, color: 'black', oc: handleShow_confirm_settings })
    return <UiSaveButtons others={btns} />
  }

  const wrapper_confirm = (footer, forRemoval) => {
    let _content = `Are you sure you want to ${forRemoval ? 'remove' : 'update'} these items?`
    switch (googleViewType) {
      case googleViewTypes.all:
        _content += 'This will replace all the data in database with these values.'
        break;
      case googleViewTypes.changed:
        _content += 'This will update the seleted values in the database with these values.'
        break;
      case googleViewTypes.filtered:
        _content += 'This will update the seleted values in the database with these values.'
        break;
    }
    return <Wrapper
      header={'Confirmation'}
      content={<div style={{ lineHeight: 1.5 }}>{_content}</div>}
      footer={footer}
      wrapperType={wrapperTypes.padded}
      updating={_isUpdating}
    />
  }

  const wrapper_data_app = (data, caption) => {

    if (showConfirm_delete) return wrapper_confirm(footer_dataApp_confirm(), true)

    return <Wrapper
      header={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>{caption}</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          {appDataDiffCounts?.appOnlyCount > 0 && <Label size='mini' color='purple'>{appDataDiffCounts?.appOnlyCount}</Label>}
          <Label size='mini' color='blue'>{_.size(data)}</Label>
        </div>
      </div>}
      content={<TransitionWrapper key={activeMenuItem} transitionWrapperType={transitionWrapperTypes.fade}>
        {_appDataDocument && data ? ims_appData(_.orderBy(data, ['lastName', 'name'])) : <div style={{ padding: '1em' }}>No Data</div>}
      </TransitionWrapper>}
      footer={footer_dataApp()}
      wrapperType={wrapperTypes.paddedHeader}
      updating={_isUpdating}
    />
  }

  const wrapper_data_google = (data, caption) => {

    return <Wrapper
      header={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>{caption}</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          {appDataDiffCounts?.sheetsOnlyCount > 0 && <Label size='mini' color='purple'>{appDataDiffCounts.sheetsOnlyCount}</Label>}
          <Label size='mini' color='blue'>{_.size(data)}</Label>
        </div>
      </div>}
      content={<TransitionWrapper key={activeMenuItem} transitionWrapperType={transitionWrapperTypes.fade}>
        {dataCollection && ims_gsData(_.orderBy(data, ['lastName', 'name']), false)}
      </TransitionWrapper>}
      wrapperType={wrapperTypes.paddedHeader}
      updating={_isUpdating}
    />
  }

  const count_props = (gvt) => {
    const _googeViewType = gvt || googleViewType
    const { dcl } = currentCount ?? {}
    let count = 0
    switch (_googeViewType) {
      case googleViewTypes.new:
        count = appDataDiffCounts?.appOnlyCount
        break;
      case googleViewTypes.all:
        count = dcl
        break;
      case googleViewTypes.changed:
        count = appDataDiffCounts?.different
        break;
      case googleViewTypes.filtered:
        count = _.size(appItemUpdateData_filtered)
        break;
    }
    return { count, color: count > 0 ? 'blue' : 'grey' }
  }

  const search = () => {
    switch (googleViewType) {
      case googleViewTypes.filtered:
        return <Dropdown
          options={opts}
          placeholder='Select Prop'
          fluid
          selection
          multiple
          style={{ margin: '1em 0' }}
          onChange={handlePropChange}
        />
    }
  }

  const wrapper_data_update = (data) => {

    if (showConfirm_update) return wrapper_confirm(footer_dataUpdate_confirm(), false)

    let _data = data

    switch (googleViewType) {
      case googleViewTypes.filtered:
        _data = appItemUpdateData_filtered
        break;
    }

    const { count, color } = count_props()

    return <Wrapper
      header={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>{googleViewType ? _.startCase(googleViewType) : 'Update Type'}</div>
        <Label size='tiny' color={color}>{count}</Label>
      </div>}
      headerr={_.startCase(googleViewType)}
      search={search()}
      content={<TransitionWrapper key={activeMenuItem} transitionWrapperType={transitionWrapperTypes.fade}>
        {_appDataDocument && !_.isEmpty(_data) ? ims_gsData(_.orderBy(_data, ['lastName', 'name']), true) : <div style={{ padding: '1em' }}>No Data</div>}
      </TransitionWrapper>}
      wrapperType={wrapperTypes.paddedHeader}
      footer={footer_dataUpdate(_data)}
      updating={_isUpdating}
    />
  }

  const menu_data_app = () => activeMenuItem ? wrapper_data_app(_appDataDocument, 'App') : <div className='cntr fw-b'></div>
  const menu_data_google = () => activeMenuItem && dataCollection ? wrapper_data_google(googleActiveDataItems, 'GS') : <div className='cntr fw-b'></div>
  const menu_data_update = () => activeMenuItem ? wrapper_data_update(appItemUpdateData, 'Update') : <div className='cntr fw-b'></div>

  const header_prod = () => <div className='topper-flex-2' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <div>{_.startCase('Settings')}</div>
    <div>
      <Label size={'mini'} color={viewType === _viewTypes.gs ? 'blue' : 'grey'} onClick={() => { handleViewType(_viewTypes.gs) }}>{'All  '} {_.startCase(_viewTypes.gs)}</Label>
      <Label size={'mini'} color={viewType === _viewTypes.gs_app ? 'blue' : 'grey'} onClick={() => { handleViewType(_viewTypes.gs_app) }}> {_.startCase(_viewTypes.gs_app)}</Label>
      <Label size={'mini'} color={viewType === _viewTypes.app_gs ? 'blue' : 'grey'} onClick={() => { handleViewType(_viewTypes.app_gs) }}> {_.startCase(_viewTypes.app_gs)}</Label>
    </div>
  </div>

  const menu_text = (key) => {
    const _text = _.startCase(key)
    const _dataCount = dataCounts ? dataCounts[key] : {}
    const { newCount } = _dataCount ?? {}
    return <div className={newCount > 0 ? 'gsin' : null}>{_text}</div>
  }

  const fnAlt_gs = (gsi) => {
    const _appDiff = appDataDiffs?.[gsi.key]
    const { counts, compares } = _appDiff ?? {}
    const { counts: ctz } = compares ?? {}
    const { different } = ctz ?? {}
    return <div style={{ display: 'flex', justifyContent: 'spaceBetween', columnGap: '.5em', alignItems: 'center' }}>
      <Label size='tiny' color='black' circular title={'App Data Count'}>{counts?.app}</Label>
      <Label size='tiny' color='blue' circular title={'Google Sheet Data Count'}>{counts?.gs}</Label>
      <Label size='tiny' color={different > 0 ? 'red' : 'grey'} circular title={'Different Count'}>{different}</Label>
      <Label size='tiny' color={counts?.new === 0 ? 'grey' : counts?.new > 0 ? 'green' : 'red'} circular title={'New Data Count'}>{counts?.new}</Label>
    </div>
  }

  const ims_googleSheetsTabs = () => {
    const _googleSheetItems = _.orderBy(googleSheetItems, ['lastName', 'firstName', 'name'])

    const hc = (item) => handleDataCollectionChange(item.key)

    return <Wrapper
      header={_.startCase('Google Sheets Tabs')}
      content={<ItemMenuSquares
        menuItems={_googleSheetItems}
        imsType={_imsTypes.inline}
        fn_altContent={fnAlt_gs}
        noItemIcon={true}
        activeItem={activeMenuItem}
        onClick={hc}
      />}
      wrapperType={wrapperTypes.paddedHeaderAndFooter}
    />
  }

  const wrapper_googleEventData = () => <Wrapper
    header={_.startCase('Google Event Data')}
    content={<TreeViewer data={googleSheetsPreview?.projectData?.eventData} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_googleData = () => <Wrapper
    header={_.startCase('Google Data')}
    content={<TreeViewer data={googleSheetsPreview?.projectData?.dataCollections} scNames={true} subNames={true} showKey={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_googleResults = () => <Wrapper
    header={_.startCase('Google Results')}
    content={<TreeViewer data={result_fromGoogle} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_appDataLinks = () => <Wrapper
    header={_.startCase('appDataLinks')}
    content={<TreeViewer data={appDataLinks} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_appDataDocuments = () => <Wrapper
    header={_.startCase('appDataDocuments')}
    content={<TreeViewer data={appDataDocuments} scNames={true} subNames={true} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const footer_settings = () => {
    const btns = []
    btns.push({ caption: `Update`, icon: 'arrow right', color: 'blue', oc: handleShow_confirm_settings, disabled: _.isEmpty(settings_google_app_gs) })
    btns.push({ caption: 'Refresh', oc: handleGetGoogleSheet, fl: true, icon: appIconTypes.refresh, color: iconColorTypes.normal, disabled: !gsid })
    return <UiSaveButtons others={btns} />
  }

  const wrapper_settings = () => {

    if (showConfirm_settings) return wrapper_confirm(footer_settings_confirm(), false)

    let tvData = {};
    switch (viewType) {
      case _viewTypes.gs:
        tvData = _settings_google
        break;
      case _viewTypes.gs_app:
        tvData = _settings_google_gs_app
        break;
      case _viewTypes.app_gs:
        tvData = settings_google_app_gs
        break;
      default:
        tvData = _settings_google
    }

    if (fromCreate) {
      tvData = _settings_google_gs_app
    }

    return <Wrapper
      header={'Settings'}
      content={<TreeViewer data={settings_google_app_gs} subNames={false} scNames={true} handlePrivate={handlePrivate} />}
      footer={footer_settings()}
      wrapperType={wrapperTypes.padded}
    />
  }

  const altSelect = (item) => {
    const { count, color } = count_props(item)
    return <Label size={'tiny'} color={color}> {count || 0}</Label>
  }

  const w_ims_select = () => {
    if (!activeMenuItem) return <div className='cntr fw-b'></div>
    const hc_select = (item) => handleGoogleViewType(item)
    return wrapper_ims(
      'Update Type',
      <ItemMenuSquares
        menuItems={googleViewTypes}
        imsType={_imsTypes.inline}
        noItemIcon={true}
        onClick={hc_select}
        activeItem={googleViewType}
        fn_altContent={altSelect}
      />
    )
  }

  /**
   * 
   * @returns WVC: four columns (Tabs, Settings, App Data, Google Data)
   */
  const menuContent = () => <WrapperVertCols mvc={_useSingleItem ? null : 'gd'}>
    {!_useSingleItem && ims_googleSheetsTabs()}
    {wrapper_settings()}
    {menu_data_app()}
    {menu_data_google()}
    {w_ims_select()}
    {menu_data_update()}
  </WrapperVertCols>


  const menuContent_create = () => <WrapperVertCols mvc={'5'}>
    {wrapper_googleResults()}
    {wrapper_settings()}
    {wrapper_googleData()}
    {wrapper_appDataLinks()}
    {wrapper_appDataDocuments()}
  </WrapperVertCols>

  const header_create = () => <div>{gsTitle || 'Missing Event Name'}</div>

  const footer_wrapper = () => {
    if (fromCreate) {
      return footer_create()
    } else {
      return footer_main()
    }
  }

  const wrapper = () => <Wrapper
    header={!_useSingleItem && !fromCreate ? buttons_top_full() : header_create()}
    content={fromCreate ? menuContent_create() : menuContent()}
    footer={((!_useSingleItem && activeMenuItem) || fromCreate) && footer_wrapper()}
    wrapperType={wrapperTypes.paddedHeader}
    updating={_isUpdating}
    noMid={!_useSingleItem}
  />

  return wrapper()

}

export default GoogleSheetsTabs

